import { useHistory } from 'react-router-dom'

import PropTypes from 'prop-types'

import { Link } from '@mui/material'

import { ReactComponent as CaretLeft } from '../../../assets/icons/caret-left.svg'

const LinkBack = ({ children, extraClass, sx }) => {
  const history = useHistory()
  const goBack = () => history.goBack()

  return (
    <Link
      component="button"
      onClick={goBack}
      className={`linkBack${extraClass ? ' ' + extraClass : ''}`}
      sx={sx}
    >
      <CaretLeft className="linkBack-icon" />
      {children}
    </Link>
  )
}

LinkBack.propTypes = {
  children: PropTypes.node.isRequired,
  extraClass: PropTypes.string,
  sx: PropTypes.object,
}

export default LinkBack
